export default __webpack_public_path__ + "static/personajeMenstruacion-b0be3bbe890e9fe17e41b236203cce38.png";